import{createContext}from"react";const AppContext=/*#__PURE__*/createContext({});export default AppContext;